import { useTranslation } from 'react-i18next';
import { Dialog, Button } from '../../../design-system';

export function WelcomeDialog({ open, onPause, onStart, error, loading }) {
  const { t } = useTranslation('common');
  return <Dialog className="guided-tour-dialog" isOpen={open} onClose={onPause}
    title={t('guided.title')} description={t('guided.welcome')}
    closeLabel={t('guided.close')} size="sm" centered
    footer={<><Button onClick={onPause}>{t('guided.pause')}</Button>
      <Button variant="primary" loading={loading} onClick={onStart}>{t('guided.start')}</Button></>}>
    <p>{t('guided.welcomeBody')}</p>
    {error && <p role="alert">{t('guided.startError')}</p>}
  </Dialog>;
}

export function FeatureIntroductionDialog({ intro, onClose, onConfirm }) {
  const { t } = useTranslation('common');
  return <Dialog className="guided-tour-dialog" isOpen={Boolean(intro)} onClose={onClose}
    title={intro ? t(`guided.features.${intro.feature}.title`) : t('guided.title')}
    description={intro ? t(`guided.features.${intro.feature}.body`) : ''}
    closeLabel={t('guided.close')} size="sm" centered
    footer={<><Button onClick={onClose}>{t('guided.later')}</Button>
      <Button variant="primary" onClick={onConfirm}>{t('guided.try')}</Button></>} />;
}

const COMPLETION_TITLES = { reading: 'readDone', ai: 'aiDone', review: 'reviewDone', cardSaved: 'cardSaved' };
export function JourneyCompletionDialog({ kind, progress, onClose, onTask, onImport, onReview }) {
  const { t } = useTranslation('common');
  const savedCard = kind === 'cardSaved';
  return <Dialog className="guided-tour-dialog" isOpen={Boolean(kind)} onClose={onClose}
    title={t(`guided.${COMPLETION_TITLES[kind] || 'readDone'}`)}
    description={t(savedCard ? 'guided.cardSavedBody' : 'guided.doneBody')}
    closeLabel={t('guided.close')} size="sm" centered
    footer={<><Button onClick={onClose}>{t('guided.continue')}</Button>
      <Button variant="primary" onClick={savedCard ? onReview : onImport}>
        {t(savedCard ? 'guided.reviewCard' : 'guided.import')}
      </Button></>}>
    {kind && !savedCard && progress.articleId && <div className="guided-tour__tasks">
      <Button disabled={Boolean(progress.completedTasks?.ai)} onClick={() => onTask('ai')}>{t('guided.exploreAI')}</Button>
      <Button disabled={Boolean(progress.completedTasks?.cards)} onClick={() => onTask('cards')}>{t('guided.exploreCards')}</Button>
    </div>}
  </Dialog>;
}
